import {error} from 'console'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../parts/crud/Charts'
import {DataRangeFilter} from '../../parts/filters/DataRangeFilter'
import {ServerFilter} from '../../parts/filters/ServerFilter'
import {TimeDimensionGroupFilter} from '../../parts/filters/TimeDimensionGroupFilter'
import moment from 'moment'
import {useState} from 'react'
import {useIntl} from 'react-intl'
import {getBaseBarChartOptions} from '../../parts/crud/Types'
import {Form} from 'react-bootstrap'

export const SingleServer = () => {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(6, 'days'),
    end: moment(),
  })
  const [server, setServer] = useState('all')
  const [groupSelected, setGroupSelected] = useState<any>(null)
  const [serversSelected, setServersSelected] = useState([])
  const [error, setError] = useState('')
  const [grouping, setGrouping] = useState('0')
  const [groupingOptionSelected, setGroupingOptionSelected] = useState<any>({})
  const [evttype, setEvtType] = useState('system')
  let params: any = {
    title: intl.formatMessage({id: 'DIAGNOSTIC.SINGLE.TITLE'}),
    subtitle: intl.formatMessage({id: 'DIAGNOSTIC.SINGLE.SUBTITLE'}),
    yAxisTitle: intl.formatMessage({id: 'DIAGNOSTIC.SINGLE.YAXISTITLE'}),

    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.0f} </b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true,
  }
  let baseChartOptions: any = {...getBaseBarChartOptions(params)}
  baseChartOptions.legend = {
    align: 'center',

    borderWidth: 1,
    backgroundColor: '#FFFFFF',
    title: {
      text: intl.formatMessage({id: 'DIAGNOSTIC.SINGLE.LEGEND_TITLE'}),
    },
  }

  baseChartOptions.chart = {
    type: 'areaspline',
    spacingBottom: 30,
    zoomType: 'x',
  }
  baseChartOptions.plotOptions = {
    area: {
      fillOpacity: 0.5,
    },
    column: {
      minPointLength: 8,
    },
  }

  const submitData = async () => {
    let has_error = false
    setError('')
    if (
      server === 'oneormore' &&
      (serversSelected === null || (Array.isArray(serversSelected) && serversSelected.length === 0))
    ) {
      setError(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_SERVER'}))
      has_error = true
    }
    if (has_error) {
      return
    }
    let data: any = {
      date_range: {
        start: dateRange.start.format('YYYY-MM-DD') + ' 00:00:00',
        end: dateRange.end.format('YYYY-MM-DD') + ' 23:59:59',
      },
      server: server,
      group_list: groupSelected ? groupSelected.value : null,
      selected_server:
        server === 'oneormore' && serversSelected
          ? serversSelected.map((srv: any) => srv.value)
          : [],
      tz: new Date().getTimezoneOffset(),
      grouping: grouping,
      group_dimension: grouping !== '0' ? groupingOptionSelected.value : '',
      evttype: evttype,
    }
    setFilterData(data)
  }
  return (
    <>
      <CrudProvider api='diagnostic/single'>
        <ChartsComponent
          withMotion={true}
          setLoading={(loading) => {
            setLoading(loading)
          }}
          filterData={filterData}
          baseChartOptions={baseChartOptions}
        >
          <p>{intl.formatMessage({id: 'DIAGNOSTIC.SYSTEM_EVENTS_TREND.TEXT'})}</p>
          <DataRangeFilter
            onChangedDataRange={(start, end) => {
              setDateRange({
                start: start,
                end: end,
              })
            }}
          />
          <TimeDimensionGroupFilter
            onChangedGrouping={(grouping) => {
              setGrouping(grouping)
            }}
            onChangedGroupingOption={(groupingOptionSelected) => {
              setGroupingOptionSelected(groupingOptionSelected)
            }}
          />
          <ServerFilter
            forceSelection={true}
            onChangedServer={(server) => {
              setServer(server)
            }}
            onChangedServersSelected={(servers) => {
              setServersSelected(servers)
            }}
            onGroupSelected={(group) => {
              setGroupSelected(group)
            }}
          />
          {error && <div className='alert alert-danger'>{error}</div>}
          <label className='mb-2 fw-bold'>
            {intl.formatMessage({id: 'GENERIC.EVENT_OF_INTEREST'})}
          </label>
          <Form.Check
            type='radio'
            id='evttype_system'
            value='system'
            label={intl.formatMessage({
              id: 'GENERIC.SYSTEM',
            })}
            checked={evttype === 'system'}
            onChange={(e) => setEvtType(e.target.value)}
            className='mb-2'
          />
          <Form.Check
            type='radio'
            id='evtype_device'
            value='device'
            label={intl.formatMessage({
              id: 'GENERIC.DEVICE',
            })}
            checked={evttype === 'device'}
            className='mb-2'
            onChange={(e) => setEvtType(e.target.value)}
          />
          <input
            type='button'
            disabled={loading}
            className='btn btn-primary'
            onClick={submitData}
            value={intl.formatMessage({id: 'GENERIC.SUBMIT'})}
            style={{float: 'left'}}
          />{' '}
          {loading && (
            <div
              className='spinner-border text-primary'
              role='status'
              style={{marginTop: '7px', float: 'left', marginLeft: '10px'}}
            >
              <span className='visually-hidden'>Loading...</span>
            </div>
          )}
        </ChartsComponent>
      </CrudProvider>
    </>
  )
}
